import { CreateGestionnaireIfNotExitGQL, GetGestionnairesGQL } from '@graphql/generated';
import { computed, inject, Injectable, signal } from '@angular/core';
import { AuthService } from '@lib/auth/auth.service';
import { lastValueFrom } from 'rxjs';
import { GestionnaireModel } from '@lib/models/demande-affiliation/gestionnaire.model';

@Injectable({
  providedIn: 'root',
})
export class GestionnaireService {
  private readonly authService = inject(AuthService);

  private readonly createGestionnaireIfNotExitGql = inject(
    CreateGestionnaireIfNotExitGQL
  );

  private readonly getGestionnairesGql = inject(GetGestionnairesGQL);

  private readonly _gestionnaireId = signal<string | undefined>(undefined);
  public readonly gestionnaireId = computed(() => this._gestionnaireId());

  private readonly _isResponsable = signal<boolean>(false);
  public readonly isResponsable = computed(() => this._isResponsable());

  private readonly _gestionnaires = signal<GestionnaireModel[]>([]);
  public readonly gestionnaires = computed(() => this._gestionnaires());

  public readonly currentGestionnaire = computed(() =>
    this.gestionnaires().find(g => g.id === this.gestionnaireId())
  );

  public async createGestionnaireIfNotExist(): Promise<void> {
    const userInfo = this.authService.userInfo();

    if (!userInfo) {
      throw "Impossible de récupérer les informations de l'utilisateur authentitifé";
    }

    const queryResult = await lastValueFrom(this.createGestionnaireIfNotExitGql.mutate());
    const response =
      queryResult.data!.createGestionnaireIfNotExist
        .createGestionnaireIfNotExistResponse!;

    this._gestionnaireId.set(response.id);
    this._isResponsable.set(response.isResponsable);
  }

  public async fetchGestionnaires() {
    this.getGestionnairesGql.watch().valueChanges.subscribe(value => {
      const gestionnaires = (value.data?.gestionnaires ?? []).filter(
        (gestionnaire): gestionnaire is GestionnaireModel =>
          !!gestionnaire.id && !!gestionnaire.nom && !!gestionnaire.prenom
      );

      this._gestionnaires.set(gestionnaires);
    });
  }
}
